<ejs-dialog
  target=".dialogs"
  class="simple-dialog"
  [cssClass]="'app-download-dialog'"
  [animationSettings]="dialogService.getAnimationSettings()"
  [resizeHandles]="dialogService.getResizeHandleDirection()"
  [position]="dialogService.getPosition()"
  [isModal]="true"
  [visible]="visible"
  [allowDragging]="false"
  [width]="'320px'"
  [height]="'auto'"
  [zIndex]="999"
  [showCloseIcon]="true"
  (beforeClose)="close()"
>
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="('APPDOWNLOAD' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
      <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('APPDONWLOADHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column align-items-center justify-content-center p-2">
      @if (downloadUrl()) {
        <a [href]="downloadUrl()!" target="_blank" rel="noopener noreferrer" class="app-download-link">
          <qrcode
            [qrdata]="downloadUrl()!"
            [width]="220"
            [margin]="1"
            [errorCorrectionLevel]="'M'"
            [ariaLabel]="('APPDOWNLOAD' | translate)"
            [alt]="('APPDOWNLOAD' | translate)"
          />
        </a>
      }
    </div>
  </ng-template>
</ejs-dialog>
